import React, { useState, useEffect, useRef, useContext } from "react";
import { useTranslation } from "react-i18next";
import { Toast } from "primereact/toast";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useSelector } from "react-redux";
import { AuthContext } from "../../Header/auth - context";
import { Button } from 'primereact/button';
import { MultiSelect } from 'primereact/multiselect';
import { Tooltip } from 'primereact/tooltip';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import handlePrintCEMT from './stranaBelaPotvrda/belaPotvrdaStampa';
import { confirmDialog } from 'primereact/confirmdialog';
import useVisinaTabele from "../../custom/visinaTabele";
import { ConfirmDialog } from 'primereact/confirmdialog'; // <- mora biti renderovana

const BelaPotvrda = () => {
  const { t } = useTranslation();

  const toast = useRef(null);
  const auth = useContext(AuthContext);
  const company = useSelector(state => state.company);
  const user = useSelector(state => state.user)
  const [tableData, setTableData] = useState(null);
  const [allColumns, setAllColumns] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [originalColumnOrder, setOriginalColumnOrder] = useState([]);
  const [selectedRowIdCemt , setSelectedRowIdCemt] = useState(null);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [first, setFirst] = useState(0);
  const [printLoading, setPrintLoading] = useState(false);
  const isSelected = (row) => String(getIdCemt(row)) === String(selectedRowIdCemt);
    const [idVehicle, setIdVehicle] = useState(null)
    const [izabran, setIzabran] = useState(false)
    /* Spisak se zavrsava na dnu ekrana; visina se MERI, ne pogadja. */
    const [omotTabele, visinaTabele, redovaTabele] = useVisinaTabele([tableData, izabran]);
const getIdCemt = (row) => row?.ID ?? row?.id ?? row?.Izaberi ?? null;
  // Path normalization and document location helper
  const getDocumentLocation = (path) => {
    if (!path) return null;
    
    // Normalize Windows path to URL format
    const normalizedPath = path.replace(/\\/g, '/');
    
    // Remove full C:/Dokumenta/ from path
    const relativePath = normalizedPath.replace(/^C:\/Dokumenta\//, '');
    const encodedPath = encodeURI(relativePath); // Encode spaces, etc.
    return `${process.env.REACT_APP_BACKEND_URL}/files/${encodedPath}`;
  };

  const handleErrors = (response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw response;
    }
  };

  useEffect(() => {

    let requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + auth.token,
      }
    };
 
    fetch(process.env.REACT_APP_BACKEND_URL + `/vehicles/cemt`, requestOptions)
      .then(handleErrors)
      .then((data) => {

        
        setTableData(data)
          // Extract all available columns from the first data row
       const firstRow = data?.[0] ?? {};
        const columns = Object.keys(firstRow)
        .filter(k => !['ID'].includes(k))
        .map(k => ({ label: k, value: k }));

        setAllColumns(columns);
        setSelectedColumns(columns.slice(0, 15).map(c => c.value));

        // -- ili, robusnije: unija ključeva kroz sve redove --
        const allKeys = Array.from(new Set(data.flatMap(obj => Object.keys(obj || {}))));
        const columnsUnion = allKeys
        .filter(k => !['ID'].includes(k))
        .map(k => ({ label: k, value: k }));

        setAllColumns(columnsUnion);
        setSelectedColumns(columnsUnion.slice(0, 15).map(c => c.value));
      })
      .catch((error) => {
        error.json().then((errorMessage) => {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: errorMessage.message,
            life: 3000,
          });
          console.log(errorMessage);
        });
      });
  }, [auth.token, company.companyId]);


  const exportExcel = async () => {
      if (!selectedColumns || selectedColumns.length === 0) return;
  
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Bele potvrde');
  
      // Use selectedColumns instead of all table keys
      const headers = selectedColumns;
  
      // Add header row
      const headerRow = worksheet.addRow(headers);
      headerRow.font = { bold: true };
      headerRow.eachCell((cell) => {
          cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFEFEFEF' }
          };
          cell.border = {
              top: { style: 'medium' },
              left: { style: 'medium' },
              bottom: { style: 'medium' },
              right: { style: 'medium' }
          };
      });
  
      // Add filtered data rows
      tableData.forEach((rowData) => {
          const row = worksheet.addRow(headers.map(h => rowData[h] ?? ""));
          row.eachCell((cell) => {
              cell.border = {
                  top: { style: 'thin' },
                  left: { style: 'thin' },
                  bottom: { style: 'thin' },
                  right: { style: 'thin' }
              };
          });
      });
  
      // Auto-size columns
      worksheet.columns.forEach((column, i) => {
          const lengths = [
              headers[i].length,
              ...tableData.map(row => (row[headers[i]] ?? "").toString().length)
          ];
          column.width = Math.max(...lengths) + 2;
      });
  
      // Serbian-formatted datetime
      const date = new Date();
      const options = {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          timeZone: 'Europe/Belgrade'
      };
      const serbianDateTime = date.toLocaleString('sr-RS', options)
          .replace(/\s/g, ' ')
          .replace(/,/g, '');
  
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      saveAs(blob, `Bele potvrde - ${company.companyName} - ${serbianDateTime}.xlsx`);
  };

    const handlePrintFuncCEMT = () => {
       
            confirmDialog({
            message: "Štampa bele potvrde?",
            acceptLabel: "Da",
            rejectLabel: "Ne",
            icon: "pi pi-info-circle",
            acceptClassName: "p-button-danger",
            accept: acceptPrint,
            reject: rejectPrint,
            });

    };
     const acceptPrint = async () => {
        if(company.companyState == "Srbija") {
             if (idVehicle) {
               setPrintLoading(true);
               let requestOptions = {
                 method: "POST",
                 headers: {
                   "Content-Type": "application/json",
                   Authorization: "Bearer " + auth.token,
                 },
                 body: JSON.stringify({
                   id: Number(idVehicle)
                 }),
               };

               try {
                 const data = await fetch(process.env.REACT_APP_BACKEND_URL + "/vehicles/printCEMT", requestOptions)
                   .then(handleErrors);
                 if (data) {
                   await handlePrintCEMT(data, process.env.REACT_APP_BACKEND_URL, auth.token);
                 }
               } catch (error) {
                 try {
                   const errorMessage = await error.json();
                   toast.current.show({ severity: "error", summary: "Error", detail: errorMessage.message, life: 3000 });
                 } catch {
                   toast.current.show({ severity: "error", summary: "Error", detail: "Greška pri generisanju PDF-a.", life: 3000 });
                 }
               } finally {
                 setPrintLoading(false);
               }
             }
        } else {
            toast.current.show({
                severity: "warn",
                summary: "Niste izabrali srpsku firmu!",
                life: 3000,
                });
        }
      };
      const rejectPrint = () => {
        console.log("Odbijeno štampanje podataka!");
      };  

  const header = (
          <div className="export-buttons fakture-stavke-header">
              <div className="fakture-stavke-radnje">
                <Button type="button" icon="pi pi-file-excel" severity="success" rounded onClick={exportExcel} data-pr-tooltip="XLS" />
                {selectedRowIdCemt && <Button type="button" style={{marginLeft:'1%'}} icon={printLoading ? "pi pi-spin pi-spinner" : "pi pi-print"} severity="secondary" rounded onClick={handlePrintFuncCEMT} disabled={printLoading} data-pr-tooltip="Preuzmi PDF" />}
              </div>
          </div>
      );

    const chooseCEMT = (rowData) => {

      const id = getIdCemt(rowData);

    setSelectedRowIdCemt((prev) => {
      const next = String(prev) === String(id) ? null : String(id);

    if(next) {
        setIdVehicle(next)
      }
      else {
      setIdVehicle(null)
      }

    return next;
  });
 
  
}

        const previewBodyTemplate = (rowData, field) => {
        const filePathsString = rowData[field];
        if (!filePathsString) return '-';
            let button;
            if(field == 'Izaberi') {
                button =   <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                <Button
                  label='Izaberi'
                  icon="pi pi-eye"
                  className="p-button-text p-button-sm"
                  onClick={(e) => chooseCEMT(rowData)}
                  tooltip="Izaberi vozilo za štampu zahteva"
                  tooltipOptions={{ position: 'top' }}
                />
              
          </div>
            }  else {
                const filePaths = filePathsString.split('|').filter(p => p.trim() !== '');

                    button = <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                    {filePaths.map((path, idx) => {
                    const documentUrl = getDocumentLocation(path);
                    if (!documentUrl) return null;
            
                    const fileNameWithExt = path.split('/').pop(); 
                    const fileName = fileNameWithExt.replace(/\.(pdf|jpg|png)$/i, '');
            
                    return (
                        <Button
                        key={idx}
                        label={fileName}
                        icon="pi pi-eye"
                        className="p-button-text p-button-sm"
                        onClick={() => window.open(documentUrl, '_blank')}
                        tooltip="Pregledaj dokument"
                        tooltipOptions={{ position: 'top' }}
                        />
                    );
                    })}
                </div>
            }
        
        return (
            button
        );
      };
    
    
      const isButtonColumn = (field) => {
        return field.startsWith('Izaberi') || 
               field.includes('File') || 
               field.includes('fajl') || 
               field.includes('upload') ||
               field.endsWith('LK') || // Lična karta
               field.endsWith('VD') || // Vozačka dozvola
               field.endsWith('PASS') || // Pasoš
               field.endsWith('VIZA') || // Viza
               field.includes('Dokument'); // Generic document
      };

  return (
    <div className="zaposleni_table_container">
      <Toast ref={toast} />
    <ConfirmDialog/>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "1em" }}>
        <div>
          <input
            type="search"
            onInput={(e) => setGlobalFilter(e.target.value)}
            placeholder={t('nova.phPretraga')}
            className="p-inputtext p-component"
          />
        </div>
      </div>
      <Tooltip target=".export-buttons>button" position="bottom" />
      <div ref={omotTabele}>
      <DataTable className="stavke-tabela"
        value={tableData || []}
        paginator
        rows={redovaTabele}
        header={header}
        first={first}
        globalFilter={globalFilter}
        onPage={(e) => setFirst(e.first)}
        scrollable
        scrollHeight={visinaTabele}
        emptyMessage={t('common.noDataTable')}
        resizableColumns
        columnResizeMode="expand"
        rowClassName={(data) => (isSelected(data) ? "selected-row" : "")}
      >

         {selectedColumns.map((colKey) => {
                const colMeta = allColumns.find(col => col.value === colKey);
                return (
                  <Column
                    key={colKey}
                    field={colKey}
                    header={colMeta?.label || colKey}
                    sortable
                    body={(rowData) => {
                      if (isButtonColumn(colKey)) {
                        return previewBodyTemplate(rowData, colKey);
                      }
                      return rowData[colKey] || '-';
                    }}
                    style={{ minWidth: '150px'}}
                  />
                );
              })}
      </DataTable>
      </div>
    </div>
  );
};

export default BelaPotvrda;